export const buttonIds = {
  overviewAddPlan: 'kpfOverviewAddPlan',
  planUpdatePlan: 'kpfPlanUpdatePlan',
  planUpdatePlanCancel: 'kpfPlanUpdatePlanCancel',
  planUpdatePlanRequest: 'kpfPlanUpdatePlanRequest',
  planUnsubscribe: 'kpfPlanUnsubscribe',
  planUnsubscribeKeep: 'kpfPlanUnsubscribeKeep',
  planUnsubscribeRequest: 'kpfPlanUnsubscribeRequest',
  changeBillingInformation: 'kpfChangeBillingInformation',
  changeBillingInformationCancel: 'kpfChangeBillingInformationCancel',
  changeBillingInformationApply: 'kpfChangeBillingInformationApply',
  changePaymentMethod: 'kpfChangePaymentMethod',
  changePaymentMethodCancel: 'kpfChangePaymentMethodCancel',
  changePaymentMethodApply: 'kpfChangePaymentMethodApply',
  downloadInvoice: 'kpfDownloadInvoice',
  addonPlanUpdate: 'kpfAddonPlanUpdate',
  addonPlanUpdateCancel: 'kpfAddonPlanUpdateCancel',
  addonPlanUpdateRequest: 'kpfAddonPlanUpdateRequest',
  addonUnsubscribe: 'kpfAddonUnsubscribe',
  addonUnsubscribeKeep: 'kpfAddonUnsubscribeKeep',
  addonUnsubscribeRequest: 'kpfAddonUnsubscribeRequest',
  planOverview: 'kpfPlanOverview',
  billingDetails: 'kpfBillingDetails',
  invoiceHistory: 'kpfInvoiceHistory',
  accountName: 'kpfAccountName',
  overviewLogout: 'kpfOverviewLogout',
  overviewLogin: 'kpfOverviewLogin',
  login: 'kpfLogin',
  forgotPassword: 'kpfForgotPassword',
  signUp: 'kpfSignUp',
  getStartedContinue: 'kpfGetStartedContinue',
  getStartedLogin: 'kpfGetStartedLogin',
  createAccount: 'kpfCreateAccount',
  purchaseContinue: 'kpfPurchaseContinue',
  checkoutPurchaseNow: 'kpfCheckoutPurchaseNow',
  confirmedLogin: 'kpfConfirmedLogin',
  addOns: 'kpfAddOns',
  resendVerification: 'kpfResendVerification',
  addPaymentMethod: 'kpfAddPaymentMethod',
  planGoToApp: 'kpfPlanGoToApp',
  planMenu: 'kpfPlanMenu',
  googleRegistration: 'kpfGoogleRegistration',
  facebookRegistration: 'kpfFacebookRegistration',
  sniperLinkVerify: 'kpfSniperLinkVerify',
  // without button info
  removeCoupon: 'kpfRemoveCoupon',
  resetPasswordSendInstructions: 'kpfResetPasswordSendInstructions',
};
